import Vue from 'vue'
import Component from 'vue-class-component'
import App from './App.vue'
import router from './router'
import store from './store'
import validation from './common/element-val'
import Axios from 'axios'
import VueI18n from 'vue-i18n'
import './assets/css/common.scss'
import { User } from '@/services/data'
import NumberText from '@/components/NumberText.vue'
import DateText from '@/components/DateText.vue'
import vuetify from './plugins/vuetify'
import vuetifyConfirm from 'vuetify-confirm'

if (window.location.protocol.startsWith('http:') && window.location.hostname !== 'localhost') {
  location.href = location.href.replace('http:', 'https:')
}

// 注册钩子函数
Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate'
])

Vue.config.productionTip = false
Axios.defaults.baseURL = process.env.VUE_APP_BASE_URL
Axios.interceptors.request.use(config => {
  // show loading
  const userData: User = store.state.user
  if (userData && userData.jwt) {
    config.headers.Authorization = 'bearer ' + userData.jwt
  }
  return config
})
// 响应拦截器
Axios.interceptors.response.use((response) => {
  return response
}, (error) => {
  if (error.response && error.response.status === 401) {
    const emptyUser: User = {
      email: null,
      jwt: null,
      accNo: null,
      name: null
    }
    store.commit('setUser', emptyUser)
  }
  return Promise.reject(error)
})

Vue.config.productionTip = false
Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: store.state.lang,
  messages: {
    en: require('./locales/en.json'),
    zh: require('./locales/zh.json')
  }
})

Vue.component('number-text', NumberText)
Vue.component('date-text', DateText)

validation.$t = function (key: string) {
  return i18n.t(key) as string
}

Vue.use(vuetifyConfirm, { vuetify })

declare module 'vue/types/vue' {
  interface Vue {
    $alert (message: string): Promise<boolean | undefined>;

    $success (message: string): Promise<boolean | undefined>;
  }
}

Vue.prototype.$alert = async function (msg: string) {
  await this.$confirm(msg, {
    title: 'Alert',
    icon: 'mdi-alert',
    color: 'orange',
    buttonFalseText: '',
    buttonTrueText: i18n.t('OK') as string
  })
}
Vue.prototype.$success = async function (msg: string) {
  await this.$confirm(msg, {
    title: 'Success',
    color: 'success',
    buttonFalseText: '',
    buttonTrueText: i18n.t('OK') as string
  })
}

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount('#app')
